<template>
  <section class="c-ui-dialog" :class="{'visible' : data.switcher}">
    <div class="container d-flex justify-content-center align-items-center h-100">
      <div class="c-ui-dialog__main">
        <section class="c-ui-dialog__body p-3 p-lg-4">
          <i v-if="data.icon" class="fs-30 alerts mb-3 d-inline-block" :class="data.icon"></i>
          <h3 v-if="data.title" class="w-bold fs-18 darks mb-2">{{ data.title }}</h3>
          <p class="w-medium mb-0">{{ data.body }}</p>

          <slot name="body"></slot>
        </section>
        <footer class="c-ui-dialog__footer d-flex justify-content-end p-3 px-lg-4">
          <slot name="navigation"></slot>
        </footer>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['data'],
  methods: {
    closeDialog() {
      this.data.switcher = false;
    },
  },
};
</script>
